import { Award, CheckCircle, Star, TrendingUp } from "lucide-react"
import SEO from "../SEO"

export default function ExcellenceReport() {
  return (
    <>
    <SEO
      title="Excellence Report | Pranaam Hospitals"
      description="Explore Pranaam Hospitals excellence report, NABH accreditation, patient safety standards, clinical excellence, and quality healthcare initiatives."
      canonical="https://pranaamhospitals.com/excellence-report"
    />
    <main className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Excellence Report</h1>
          <p className="text-lg md:text-xl text-white/90">Our Commitment to Quality Healthcare</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/wp-content/uploads/2026/05/PranaamHospitalsAwards-1.webp" alt="Awards" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Quality & Excellence in Healthcare</h2>
          <p className="text-gray-600 mb-6">
            Pranaam Hospitals maintains the highest standards of healthcare delivery through continuous quality improvement, 
            patient safety initiatives, and evidence-based medical practices. Our excellence report showcases our commitment 
            to providing world-class healthcare services.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">NABH Accreditation</h3>
            <p className="text-gray-600">Certified by National Accreditation Board for Hospitals & Healthcare Providers</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Patient Safety</h3>
            <p className="text-gray-600">Implementing international patient safety protocols and standards</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Star className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Clinical Excellence</h3>
            <p className="text-gray-600">Recognized for outstanding clinical outcomes and patient satisfaction</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <TrendingUp className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Continuous Improvement</h3>
            <p className="text-gray-600">Regular audits and quality assessments to enhance healthcare delivery</p>
          </div>
        </div>
      </div>
    </main>
    </>
  )
}
